import make, { Enum } from '@xaamin/enum';

class FacturasGlobalesTicketStatus extends Enum {
  name = 'FacturasGlobalesTicketStatus';

  enum = {
    pending: 0,
    cancelled: -1,
    error: -2,
    failed: -3,
    success: 1,
    stamping: 2,
    duplicate: 3,
    queued: 4,
    replace: 7,
    undefined: 999,
  };
}

export default make(FacturasGlobalesTicketStatus);
